type CacheGet = <T>(
  storage: Storage,
  key: string,
  deleteAfterGet?: boolean
) => T

type CacheSet = (
  storage: Storage,
  key: string,
  deleteAfterGet?: boolean
) => boolean | undefined

type CacheRemove = (storage: Storage, key: string) => void

interface Cache {
  get: CacheGet
  set: CacheSet
  remove: CacheRemove
  getLocalStorage: (key: string, deleteAfterGet?: boolean) => any
  setLocalStorage: (key: string, deleteAfterGet?: boolean) => any
  removeLocalStorage: (key: string) => void
  getSessionStorage: (key: string, deleteAfterGet?: boolean) => any
  setSessionStorage: (key: string, deleteAfterGet?: boolean) => any
  removeSessionStorage: (key: string, deleteAfterGet?: boolean) => void
}

class Cacher implements Cache {
  getLocalStorage(key: string, deleteAfterGet?: boolean) {
    return this.get(window.localStorage, key, deleteAfterGet)
  }
  setLocalStorage(key: string, value: any) {
    return this.set(window.localStorage, key, value)
  }
  removeLocalStorage(key: string) {
    this.remove(window.localStorage, key)
  }
  getSessionStorage(key: string, deleteAfterGet?: boolean) {
    return this.get(window.sessionStorage, key, deleteAfterGet)
  }
  setSessionStorage(key: string, value: any) {
    return this.set(window.sessionStorage, key, value)
  }
  removeSessionStorage(key: string) {
    this.remove(window.sessionStorage, key)
  }
  get(storage: Storage, key: string, deleteTag?: boolean) {
    if (storage) {
      let value = storage.getItem(key)
      if (deleteTag) {
        storage.removeItem(key)
      }

      if (!storage.__memory && value && value.indexOf("{") === 0) {
        try {
          return JSON.parse(value)
        } catch (e) {
          return value
        }
      }
      return value
    }
  }
  set(storage: Storage, key: string, value: any) {
    if (!storage) {
      return
    }
    if (!storage.__memory && typeof value === "object") {
      try {
        value = JSON.stringify(value)
      } catch (e) {
        return false
      }
    }
    storage.setItem(key, value)

    return true
  }
  remove(storage: Storage, key: string) {
    storage.removeItem(key)
  }
}

export default Cacher
